/* printerhive-bg-param-20260530: keep PrinterHive widget background aligned with Shopify page background */
(function(){
  var BG='ffffff';
  function applyPrinterHiveBg(){
    document.querySelectorAll('printerhive-calculator').forEach(function(el){
      if(!el.getAttribute('bg')) el.setAttribute('bg', BG);
      var iframe = el.querySelector('iframe[src*="app.printerhive.com/calculator/"]');
      if(iframe && iframe.src){
        try{
          var url = new URL(iframe.src);
          if(url.searchParams.get('bg') !== BG){
            url.searchParams.set('bg', BG);
            iframe.src = url.toString();
          }
        }catch(e){}
      }
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyPrinterHiveBg);
  else applyPrinterHiveBg();
  setTimeout(applyPrinterHiveBg, 100);
  setTimeout(applyPrinterHiveBg, 800);
})();
